/* Upsells du panier — memoire du choix + resynchronisation.  v6, 2026-08-03.

   N'intercepte RIEN : ni fetch, ni /cart/add, ni le comportement du theme.

   ── 1. Memoire du choix ──
   `data-selected` est re-rendu depuis le reglage « pre-coche » a chaque rendu
   du panier : le theme rajoutait donc l'upsell que le client venait de
   retirer. On note son refus dans un attribut de panier, relu par le Liquid.

   ── 2. Resynchronisation ──
   Le theme n'appelle `initToggleUpsells()` qu'UNE FOIS, au parse du script,
   panier encore vide. Apres un ajout produit le tiroir se re-rend, mais plus
   rien ne rappelle la synchro : les upsells restaient coches sans jamais etre
   ajoutes au total.

   ── Historique des echecs, pour ne pas les refaire ──
   v2/v3 appelaient `addToCart()` du theme, une fois par upsell. Chaque appel
   soumet un formulaire qui re-rend une section : deux soumissions coup sur
   coup faisaient injecter la mauvaise section dans le tiroir (la page panier
   complete s'affichait dans le tiroir, colonnes cassees), et la garde basee
   sur le DOM produisait des doublons.

   v5 faisait UN SEUL appel /cart/add.js groupe puis UN SEUL rendu. Correct,
   mais elle n'AJOUTAIT que. Un interrupteur eteint avec l'article encore au
   panier n'etait plus reconcilie : le client payait 4,95 EUR invisibles
   (constate le 2026-08-03 sur le tablier Hutchins, 2 interrupteurs eteints et
   un sous-total de 84,90 EUR).

   v6 aligne le panier sur les interrupteurs DANS LES DEUX SENS : ajoute ce qui
   est coche et absent, retire ce qui est decoche et present. Toujours en un
   minimum d'appels, puis UN SEUL rendu. */
(function () {
  var CLE = 'upsell_refuse_';
  var fait = false;            // une seule resynchronisation par page
  var enCours = false;
  var minuteur = null;

  function estBascule(el) {
    return el && el.dataset && el.dataset.id && el.dataset.toggle !== 'false';
  }

  // ── 1. Memoriser le refus ────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var cible = e && e.target;
    if (!cible || typeof cible.closest !== 'function') return;
    var el = cible.closest('cart-drawer-upsell,cart-drawer-gift');
    if (!estBascule(el)) return;
    var handle = el.dataset.handle;
    if (!handle) return;
    fait = true;                // le client prend la main : on ne resynchronise plus
    setTimeout(function () {
      var refuse = el.dataset.selected !== 'true';
      var attrs = {};
      attrs[CLE + handle] = refuse ? '1' : '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }, 350);
  }, false);

  // ── 2. Resynchronisation groupee ─────────────────────────────────────
  function sectionsARendre(tiroir) {
    try {
      if (typeof tiroir.getSectionsToRender === 'function') {
        return tiroir.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
      }
    } catch (e) {}
    return ['cart-drawer'];
  }

  function resynchroniser() {
    if (fait || enCours) return;
    var tiroir = document.querySelector('cart-drawer');
    if (!tiroir || tiroir.classList.contains('is-empty')) return;

    enCours = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (panier) {
        if (!panier) { enCours = false; return; }
        var presents = {};
        (panier.items || []).forEach(function (i) { presents[String(i.variant_id)] = true; });

        var aAjouter = [], aRetirer = [];
        tiroir.querySelectorAll('cart-drawer-upsell,cart-drawer-gift').forEach(function (el) {
          if (!estBascule(el)) return;
          var id = String(el.dataset.id);
          var voulu = el.dataset.selected === 'true';
          if (voulu && !presents[id] && aAjouter.indexOf(id) === -1) aAjouter.push(id);
          // Decoche mais encore au panier : c'est le cas qui facturait en silence.
          if (!voulu && presents[id] && aRetirer.indexOf(id) === -1) aRetirer.push(id);
        });
        if (!aAjouter.length && !aRetirer.length) { fait = true; enCours = false; return; }

        fait = true;   // pose AVANT l'appel : aucune seconde salve possible
        var sections = sectionsARendre(tiroir);
        var url = window.location.pathname;

        var etape = Promise.resolve(null);
        if (aAjouter.length) {
          etape = etape.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: aAjouter.map(function (id) { return { id: Number(id), quantity: 1 }; }),
                sections: sections, sections_url: url
              })
            }).then(function (r) { return r.ok ? r.json() : null; });
          });
        }
        if (aRetirer.length) {
          etape = etape.then(function (prec) {
            var updates = {};
            aRetirer.forEach(function (id) { updates[id] = 0; });
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates, sections: sections, sections_url: url })
            }).then(function (r) { return r.ok ? r.json() : prec; });
          });
        }

        return etape
          .then(function (reponse) {
            if (!reponse) return;
            try {
              if (typeof tiroir.renderContents === 'function') tiroir.renderContents(reponse);
            } catch (e) {}
            document.dispatchEvent(new CustomEvent('cartQuantityUpdated'));
          })
          .catch(function () {});
      })
      .catch(function () {})
      .then(function () { enCours = false; });
  }

  function planifier() {
    if (fait) return;
    if (minuteur) clearTimeout(minuteur);
    minuteur = setTimeout(resynchroniser, 700);
  }

  function observer() {
    var tiroir = document.querySelector('cart-drawer');
    if (!tiroir) return false;
    new MutationObserver(planifier).observe(tiroir, { childList: true, subtree: true });
    planifier();
    return true;
  }

  document.addEventListener('cartQuantityUpdated', planifier, false);

  if (!observer()) {
    var attente = new MutationObserver(function () { if (observer()) attente.disconnect(); });
    attente.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
